import React, { useEffect, useState } from "react"
import LayoutDumpster from "../components/layout-dumpster"
import RelatedServices from '../components/related-services'
import PopularServices from '../components/popular-services'
// import PopularArticles from '../components/popular-articles'
// import ZipFinderKpps from '../components/zip-finder-kpps'
import KppTips from "../components/kpptips"
import HowToGuide from '../components/how-to-guides-dumpsters'
import ProfilesCardsDumpster from "../components/profiles-cards-dumpsters"
import EmptyProfilesDumpster from "../components/empty-profiles-dumpster"
import BlockHowToGuidesJunkRemoval from "../components/how-to-guides-junk-removal"
import Banner from "../components/banner"
// import ViewDumpsterPricesForm from "../components/viewDumpsterPricesForm";
import PopularArticlesKpp from "../components/popular-articles-kpp"
import SidebarForm from "../components/sidebarForm"

const DumpsterKPP = ({ pageContext }) => {
    const cards = pageContext.cards
    const sponsoredCards = pageContext.sponsoredCards
    const title = pageContext.title
    const projectTypeName = pageContext.keyword_group?.name || '';
    const profiles = pageContext.profiles.length > 0 ? pageContext.profiles[0] : [];
    const sponsoredProfiles = pageContext.sponsoredProfiles?.length > 0 ? pageContext.sponsoredProfiles[0] : [];
    const env = pageContext.env
    const articles = pageContext.articles
    const code = pageContext.code
    const codes = pageContext.codes.length > 0 ? pageContext.codes : []
    const populars = pageContext.populars.length > 0 ? pageContext.populars : []
    const related = pageContext.related
    // const keygroup_name = pageContext.page === 'kpp' ? undefined : pageContext.keyword_group.name
    // const bread = pageContext.page === 'kpp' ? undefined : (pageContext.bread ? pageContext.bread.url : '#')
    const tip = pageContext.tips.length > 0 ? pageContext.tips[0] : {}

    // const text = code === 'junk-removal' ? 'Get matched to top-rated junk removal services' : 'Find the top dumpster rental companies serving your hometown';
    const empty = profiles.length > 0 ? false : true

    const place =
    {
        name: pageContext.place.name,
        ht: pageContext.place.ht,
        state:
        {
            name: pageContext.place.state.name,
            av: pageContext.place.state.av,
            slug: pageContext.place.state.slug
        }
    }

    

    const seo_desc = pageContext.seo_desc
    const seo =
    {
        url: pageContext.url,
        env: env,
        place: place,
        code: code,
        page: pageContext.page,
        seo_desc: seo_desc,
        schema: pageContext.schemaOrg
    }

    const online_booking_pros = pageContext.enabledBooking

    const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth <= 992)
    const [isHorizontal, setIsHorizontal] = useState(typeof window !== "undefined" && window.innerWidth <= 992 && (window.innerWidth >= window.innerHeight))

    useEffect(() => {
        if(code === 'dumpster') {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 992);
                setIsHorizontal(window.innerWidth >= window.innerHeight)
            };
        
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, []);

    return (
        <LayoutDumpster seo={seo} env={env} code={code} hidden={true} defaultStyles={{ maxWidth: '1920px', margin: 'auto', width: '100%' }} notShowHeader={code === 'dumpster' && isHorizontal && isMobile}>
            <div className="top-kpp-container" >
                <div className="left-side-dumpster">
                    <Banner
                    code={code}
                    codes={codes}
                    env={env}
                    title={title}
                    url={pageContext.url}
                    place={place}
                    breadcrumb={true}
                    />
                    <div id="sponsored-profiles-id-list" className="div d-none" data-htcode={code === 'dumpster' ? 'dumpster-rental' : code === 'comercial-trash-service' ? 'commercial-waste-management' : code}>{pageContext.sponsoredPros}</div>

                    {sponsoredProfiles?.length > 0 &&
                    <>
                        <div className="container">
                            <h2 className="cards-title">Sponsored results</h2>
                        </div>
                        <ProfilesCardsDumpster 
                            profiles={sponsoredProfiles} 
                            env={env} 
                            code={code} 
                            place={place} 
                            cards={sponsoredCards} 
                            online_booking_pros={online_booking_pros}
                            paginated={false}
                            eventClass="sponsoredProCardRendered"
                            cardClass="sponsored-card-pro-view"
                        />
                    </>
                    }

                    <div id="profiles-id-list" className="div d-none" data-htcode={code === 'dumpster' ? 'dumpster-rental' : code === 'comercial-trash-service' ? 'commercial-waste-management' : code}>{pageContext.pros}</div>

                    {empty && <EmptyProfilesDumpster code={code} />}

                    {!empty &&
                    <>
                        <div className="container">
                            <h2 className="cards-title" style={{ marginTop: sponsoredProfiles?.length > 0 ? '40px' : '20px' }}>{`All "${projectTypeName}" results near me in ${place.name} - ${new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' })}`}</h2>
                        </div>
                        <ProfilesCardsDumpster 
                            profiles={profiles} 
                            env={env} 
                            code={code} 
                            place={place} 
                            cards={cards} 
                            online_booking_pros={online_booking_pros}
                            paginated={true}
                            eventClass="proCardRendered"
                            cardClass="card-pro-view"
                        />
                    </>
                    }
                    {code === 'dumpster' && isMobile &&
                    <div className="kpp-video-container-desktop">
                        <h2>Get Dumpster Pricing and Availability in {place.name}</h2>
                        <div class="howvideo services mb-5">
                            <iframe
                                src='https://www.youtube-nocookie.com/embed/0QgduQnNCMM' 
                                width="560" 
                                height="315" 
                                frameborder="0" 
                                loading="lazy"
                            />
                        </div>
                    </div>
                    }
                </div>
                <div className="col-4 view-prices-form fixed-right" >
                    <SidebarForm site={env.site} code={code} notShow={code === 'dumpster' && isHorizontal && isMobile}/>
                    {code === 'dumpster' && !isMobile &&
                    <div className="kpp-video-container-mobile">
                        <div class="howvideo services mb-5">
                            <iframe
                                src='https://www.youtube-nocookie.com/embed/0QgduQnNCMM' 
                                width="560" 
                                height="315" 
                                frameborder="0" 
                                // loading="lazy"
                            />
                        </div>
                    </div>
                    }
                </div>
            </div>

            <div className="pt-5 pb-5 left-side-dumpster" >
                <div className="container ">
                    <div className="column">
                        {related?.length > 0 && <div className="col-md-12"><RelatedServices env={env} services={related} place={place} code={code} /></div>}
                        {populars?.length > 0 && <div className="col-md-12"><PopularServices env={env} services={populars} place={place} code={code} /></div>}
                        <div className="col-md-12">
                            {code !== 'junk-removal' ?
                            <HowToGuide />
                            :
                            <BlockHowToGuidesJunkRemoval />
                            }
                        </div>
                    </div>
                    <div className='stateArticles'><PopularArticlesKpp articles={articles} /></div>
                </div>
            </div>

            <div className="container-fuild left-side-dumpster">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <KppTips tip={tip} codes={codes} code={code} place={place} />
                        </div>
                    </div>
                </div>
            </div>
        </LayoutDumpster>
    )
}

export default DumpsterKPP